/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState,useEffect} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import { useAuth, AuthPasswordValidationSchema, userValidateForgetPasswordOTP } from '../../../auth'
import {PasswordMeterComponent} from '../../../../../_metronic/assets/ts/components'

import { useNavigate } from "react-router-dom";
import { StatusErrorMessage } from '../../../../components/widgets'
import { getErrorMessage } from '../../../../components/helpers'

const forgotOTPSchema = Yup.object().shape({    
    otp: Yup.string().trim()
        .min(2, 'Minimum 2 symbols')
        .max(16, 'Maximum 50 symbols')
        .required('OTP is required'),
    password: AuthPasswordValidationSchema.required('Password Required'),
    checkpassword: Yup.string().trim()
        .required('Password confirmation is required')
        .when('password', {
            is: (val: string) => (val && val.length > 0 ? true : false),
            then: (schema) => schema.oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
        }),
})

const initialValues = {
    otp: '',    
    password: '',
    checkpassword: '',
}

/*
    Formik+YUP+Typescript:
    https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
    https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function SetscoForgotPasswordOTP() {
    const [loading, setLoading] = useState(false)
    const {auth} = useAuth()
    
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues,    
        validationSchema: forgotOTPSchema,
        onSubmit: (values, {setStatus, setSubmitting}) => {
            setLoading(true)

            const params = {
                username: auth?.email ? auth.email : '',
                otp : values.otp, 
                password : values.password
            }

            async function validateOTP(data: any) { 
                await userValidateForgetPasswordOTP(data.username, data.otp, data.password)
                .then( res => {
                    if (! (res && res.success)) {
                        setStatus((res && res.message) ? res.message : 'Something happened');
                        return;
                    }
                    navigate("/setsco/auth");
                })  
                .catch((err) => {                    
                    setStatus(getErrorMessage(err));                
                })
                .finally( () =>  {
                    setSubmitting(false)
                    setLoading(false)
                })
            }

            validateOTP(params);
            
        },
    })

    useEffect(() => {
        PasswordMeterComponent.bootstrap()
    }, [])


    return (
    <>
    <div>
        <div className="p-6 text-center" style={{marginTop: '-60px'}}>
            <img src={toAbsoluteUrl('/media/brand/Setsco_BrandSig_2D_white.png')} className="h-80px" alt='setsco' />
        </div>     
        <form
            className="form w-100 w-lg-400px bg-white rounded-4 overflow-hidden"
            onSubmit={formik.handleSubmit}
            noValidate
            id='kt_login_signin_form'
        >
            <div className="bg-secondary fs-6 text-white p-6 text-center">
                CERTIFICATION APPLICATION & MANAGEMENT SYSTEM
            </div>
            <div className="p-10 d-flex flex-column gap-4 mb-10">
                <div className="text-center text-info fw-bold fs-1">
                    Reset User Password
                </div>
                <div className="text-center text-info fs-5">
                    Please check your email for OTP.
                </div>
                <div className='fv-row'>                
                    <input
                        placeholder='Enter OTP'
                        {...formik.getFieldProps('otp')}
                        className={clsx(
                            'form-control bg-transparent',
                            {'is-invalid': formik.touched.otp && formik.errors.otp},
                            {'is-valid': formik.touched.otp && !formik.errors.otp,}
                        )}
                        type='input'
                        name='otp'
                        autoComplete='off'
                    />
                    {formik.touched.otp && formik.errors.otp && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.otp}</span>
                        </div>
                    </div>
                    )}
                </div>

                <div className='fv-row' data-kt-password-meter='true'>
                    <div className='mb-1'>                
                        <div className='position-relative mb-3'>
                            <input
                                type='password'
                                placeholder='New Password'
                                autoComplete='off'
                                {...formik.getFieldProps('password')}
                                className={clsx(
                                    'form-control bg-transparent',
                                    {'is-invalid': formik.touched.password && formik.errors.password,},
                                    {'is-valid': formik.touched.password && !formik.errors.password,}
                                )}
                            />
                            {formik.touched.password && formik.errors.password && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.password}</span>
                                </div>
                            </div>
                            )}
                        </div>          
                        <div
                            className='d-flex align-items-center mb-3'
                            data-kt-password-meter-control='highlight'
                        >
                            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
                        </div>          
                    </div>
                    <div className='text-muted fs-8'>
                        Use 8 or more characters with a mix of letters, numbers & symbols.
                    </div>
                </div>
        
                <div className='fv-row mb-5'>        
                    <input
                        type='password'
                        placeholder='Password confirmation'
                        autoComplete='off'
                        {...formik.getFieldProps('checkpassword')}
                        className={clsx(
                            'form-control bg-transparent',
                            {'is-invalid': formik.touched.checkpassword && formik.errors.checkpassword,},
                            {'is-valid': formik.touched.checkpassword && !formik.errors.checkpassword,}
                        )}
                    />
                    {formik.touched.checkpassword && formik.errors.checkpassword && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.checkpassword}</span>
                        </div>
                    </div>
                    )}
                </div>      
                
                <StatusErrorMessage status={formik.status} />
                
                <div className="d-flex flex-stack flex-wrap gap-3 justify-content-start align-items-center">
                    <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className='btn btn-info px-10'
                        disabled={formik.isSubmitting || !formik.isValid}
                    >
                        {!loading && <span className='indicator-label'>Reset Password</span>}
                        {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                        )}
                    </button>                
                    <Link to='/setsco/auth/login' className="link-info">
                        Back to Login
                    </Link>        
                    <div />        
                </div>    
            </div>
            
        </form>
    </div>
    </>
    )
}
